import { Icon } from '@web-apps/ui-shared'
import {
  StyledFooterContainer,
  StyledLink,
  StyledMessageContainer,
} from './Footer.styles'

type FooterProps = {
  url: string
  title: string
  onFooterClick?: () => void
}

export const Footer = ({ url, title, onFooterClick }: FooterProps) => {
  return (
    <StyledFooterContainer>
      <StyledLink href={url} onClick={onFooterClick}>
        <StyledMessageContainer>
          <span>{title}</span>
          <Icon.MetapicLogo width={66} height={16} />
        </StyledMessageContainer>
      </StyledLink>
    </StyledFooterContainer>
  )
}
